const handleVariantButtonClick = () => {
	setTimeout(() => {
		const selectedVariant = window.location.search.split('variant=')[1];
		const inventoryWrapper = document.querySelectorAll('.inventory-wrapper');

		if (selectedVariant && variantStock[selectedVariant] !== undefined) {
			if (inventoryWrapper.length > 0) {
				inventoryWrapper.forEach((wrapper) => {
					wrapper.setAttribute('data-variant-stock', variantStock[selectedVariant]);

					if (variantStock[selectedVariant] == '0') {
						variantInventoryPolicy[selectedVariant] == 'continue'
							? (wrapper.innerHTML = 'In Stock')
							: (wrapper.innerHTML = wrapper.dataset.outStockText
									? wrapper.dataset.outStockText
									: window.currentProductPersonalisation.outOfStockText);
					} else {
						wrapper.innerHTML = `<span class="text-subdued">Available stock:</span> ${variantStock[selectedVariant]} cups`;
					}
				});
			}
		}
	}, 500);
};

const formInput = document.querySelector('form.shopify-product-form input[name="id"]');
formInput.addEventListener('change', handleVariantButtonClick);
document.addEventListener('check-personalization-inventory', handleVariantButtonClick);
